/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// error message
import ErrorTemplate from 'pages/error/error_template/error_template';
// ctas
import Button from 'material/ctas/button/button_container';
// graphics
import Illustration from 'material/graphic/illustration/illustration';
// styles
// import injectSheet from 'react-jss';
// import styles from 'pages/error/500/500_styles';



/* ========== ~~~~~~~~~~ ERROR : 403 ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const Error403 = (props) => {
    // if this param is true, then on clicking back button, the window will jump back 2 pages, otherwise it will jump back only one screen
    const home = !!props.match.params.home;
    const backButtonAction = () => { home ? props.moveToPage(`dashboard/home`) : window.history.back() };

    return(
        <ErrorTemplate 
        	styles={'error403'}
            code={`403`}
            title={<h2>Forbidden</h2>}
            bodycopy={<p>We’re sorry, you do not have permission to view this page or resource.</p>}
            button={<Button type={`custom`} handleClick={backButtonAction} variant={`primary`} name={`back`} text={`Back`} />}
            illustration={<Illustration name={`error-403`} text={`Error Illustration`} />}
        />
    );
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default Error403;
// export default injectSheet(styles)(error500);
